"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Input = void 0;
const tslib_1 = require("tslib");
require("react-datepicker/dist/react-datepicker.css");
const polished_1 = require("polished");
const styled_components_1 = tslib_1.__importDefault(require("../Themes/styled-components"));
const DatePickerWrapper = styled_components_1.default.div `
  width: 100%;

  .react-datepicker__time-list {
    padding: 0px;
  }

  .react-datepicker__input-container {
    width: 100%;
  }

  .react-datepicker-wrapper {
    width: 100%;
  }

  .react-datepicker-popper {
    z-index: 15;
    min-width: ${(0, polished_1.rem)(320)};
  }

  .react-datepicker__close-icon::after {
    background-color: transparent;
    color: #6e6e6e;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: ${(0, polished_1.rem)(15)};
  }

  .react-datepicker__close-icon {
    display: block;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: ${(0, polished_1.rem)(10)};
  }
`;
exports.default = DatePickerWrapper;
var Input_1 = require("../Input");
Object.defineProperty(exports, "Input", { enumerable: true, get: function () { return tslib_1.__importDefault(Input_1).default; } });
